import { Injectable } from "@angular/core";
import { EmailStatsByDate, EmailStatsDTO } from "@dto/rates/email-stats.dto";
import { FilterData } from "@entity/filter-data.entity";
import { environment } from "@environments/environment";
import { GranularityType } from "@type/granularity.type";
import { formatDateToISOFormatWhithoutZoneTime } from "@utils/date.utils";
import { map, Observable } from "rxjs";
import { AuthHttpClientService } from "./auth-http-client.service";
import { EmailStatsWhenSent, EmailStatsWhenSentDTO } from "@dto/rates/email-stats-when-sent.dto";
import { ProvidersStats, ProvidersStatsDTO } from "@dto/rates/providers-stats";

@Injectable({
  providedIn: 'any',
})
export class RateService {
  private readonly url: string = `${environment.tmnBackApi}/rates`;

  constructor(private readonly http: AuthHttpClientService) { }

  getRateEmailStats(filters: FilterData, granularity: GranularityType): Observable<EmailStatsByDate> {
    return this.http.post<EmailStatsDTO>(`${this.url}/email-stats`, {
      productIds: filters.productId,
      eventTypes: filters.eventType,
      fromDate: formatDateToISOFormatWhithoutZoneTime(new Date(filters.period.from)),
      toDate: formatDateToISOFormatWhithoutZoneTime(new Date(filters.period.to)),
      granularity
    }).pipe(
      map(response => response.data)
    );
  }

  getRateEmailStatsWhenSent(filters: FilterData): Observable<EmailStatsWhenSent> {
    return this.http.post<EmailStatsWhenSentDTO>(`${this.url}/email-stats-when-sent`, {
      productIds: filters.productId,
      eventTypes: filters.eventType,
      fromDate: formatDateToISOFormatWhithoutZoneTime(new Date(filters.period.from)),
      toDate: formatDateToISOFormatWhithoutZoneTime(new Date(filters.period.to))
    }).pipe(
      map(response => response.data)
    );
  }

  getRateProviderStats(filters: FilterData): Observable<ProvidersStats> {
    return this.http.post<ProvidersStatsDTO>(`${this.url}/providers-stats`, {
      fromDate: formatDateToISOFormatWhithoutZoneTime(new Date(filters.period.from)),
      toDate: formatDateToISOFormatWhithoutZoneTime(new Date(filters.period.to))
    }).pipe(
      map(response => response.data)
    );
  }

}